import { actionCreator } from 'utils';
import { LOAD_HISTORY, REMOVE_HISTORY, SET_HISTORY_PAGINATION, LOAD_DISPLAY_USERS_HISTORY } from '../types/historyTypes';

const initState = {
    loading: true,
    error: false,
    listing: null,
    limit: 5,
    offset: 0,
    displayUsers: [],
};

export default function (state = initState, action) {
    switch (action.type) {
    case LOAD_HISTORY:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(LOAD_HISTORY, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(LOAD_HISTORY, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case REMOVE_HISTORY:
        return Object.assign({}, state, initState);

    case SET_HISTORY_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case LOAD_DISPLAY_USERS_HISTORY:
        return Object.assign({}, state, {
            displayUsers: action.data,
        });

    default:
        return state;
    }
}
